module.exports = __webpack_public_path__ + "media/images/dropdown-c44014b01663714a02c73021f3e938a4.svg";